module.exports = __webpack_public_path__ + "static/media/sidemenu-invoices.01dc54a0.svg";